<template>
    <div class="container-fluid">
        <section class="disputes-shell">
            <div class="disputes-hero">
                <div class="disputes-hero-copy">
                    <p class="hero-eyebrow">Dispute Center</p>
                    <h1>Monitor and resolve customer disputes</h1>
                    <p class="hero-text">Review dispute tickets, assess severity, and move cases through resolution with a clearer administrative workflow.</p>
                </div>
                <div class="disputes-stats">
                    <div class="disputes-stat-card">
                        <span class="stat-label">Total Disputes</span>
                        <strong>{{ disputeQty || 0 }}</strong>
                        <span class="stat-note">Tickets currently in the system</span>
                    </div>
                    <div class="disputes-stat-card disputes-stat-card-soft">
                        <span class="stat-label">Signed In As</span>
                        <strong>{{ firstname }} {{ lastname }}</strong>
                        <span class="stat-note">{{ email_address || 'Administrator' }}</span>
                    </div>
                </div>
            </div>

            <div class="dispute-summary-grid">
                <div class="summary-card">
                    <span class="summary-label">Open Cases</span>
                    <strong>{{ openDisputes }}</strong>
                    <p>Require administrative attention.</p>
                </div>
                <div class="summary-card summary-card-progress">
                    <span class="summary-label">In Progress</span>
                    <strong>{{ inProgressDisputes }}</strong>
                    <p>Already assigned or under review.</p>
                </div>
                <div class="summary-card summary-card-resolved">
                    <span class="summary-label">Resolved</span>
                    <strong>{{ resolvedDisputes }}</strong>
                    <p>Successfully closed dispute tickets.</p>
                </div>
            </div>

            <div class="account-details disputes-table-card">
            <div class="col-sm-12 table table-responsive disputes-table-inner">
                <div class="contract-header">
                    <div>
                        All Disputesxx
                        <span class="disputes-count">{{ disputeQty || 0 }}</span>
                    </div>
                    <div class="table-heading-meta">
                        <p class="disputes-note">Track ticket priority, current status and next administrative action.</p>
                        <span class="table-meta-chip">Admin Queue</span>
                    </div>
                </div>
    
                <div class="table table-responsive table-sm disputes-table-wrap">
                    <v-data-table :headers="header" :items="desserts" dense class="disputes-data-table table-responsive">
                        <template v-slot:item.ticketid="{ item }">
                            <div class="a-text">{{ item.ticketid }}</div>
                        </template>
                        <template v-slot:item.customer="{ item }">
                            <div class="a-text">{{ item.customer }} 
                            </div>
                        </template>
                        <!-- <template v-slot:item.acceptedby="{ item }">
                            <div class="a-text">{{ item.acceptedby }}</div>
                        </template> -->
                        <template v-slot:item.disputetype="{ item }">
                            <div class="a-text">{{ item.disputetype }}</div>
                        </template>
                        <template v-slot:item.contract="{ item }">
                            <div class="a-text">{{ item.contract }}</div>
                        </template>
                        <template v-slot:item.description="{ item }">
                            <div class="a-text" v-html="item.description"></div>
                        </template>
                        <template v-slot:item.priority="{ item }">
                            <div class="a-text">
                                <span class="priority-chip high" v-if="item.priority == 'High'">{{ item.priority }}</span>
                                <span class="priority-chip medium" v-else-if="item.priority == 'Medium'">{{ item.priority }}</span>
                                <span class="priority-chip low" v-else-if="item.priority == 'Low'">{{ item.priority }}</span>
                            </div>
                        </template>
                        <template v-slot:item.status="{ item }">
                            <div class="a-text">
                                <span class="status-chip open" v-if="item.status == 1">Open</span>
                                <span class="status-chip progress" v-else-if="item.status == 2">In Progress</span>
                                <span class="status-chip resolved" v-else-if="item.status == 3">Resolved</span>
                            </div>
                        </template>
                                       
                        <template v-slot:item.action="{ item }">
                            <div class="dispute-actions">
                                <button
                                    @click="in_progress(item.disputeid)"
                                    class="btn btn-primary btn-xs dispute-action-btn secondary-action"
                                    :disabled="item.status == 2 || item.status == 3"
                                >
                                    In Progress
                                </button>
                                <button
                                    @click="dispute_resolve(item.disputeid)"
                                    class="btn btn-success btn-xs dispute-action-btn primary-action"
                                    :disabled="item.status == 3"
                                >
                                    Resolve
                                </button>
                            </div>
                        </template>
                        <template v-slot:no-data>
                            <div class="disputes-empty-state">
                                <i class="fa fa-life-ring"></i>
                                <h4>No disputes found</h4>
                                <p>Dispute tickets will appear here once customers raise issues for review.</p>
                            </div>
                        </template>
                        
                    </v-data-table>
                </div>
            </div>
        </div>
        </section>

        <!-- <div v-if="isContractLink">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper col-md-5" style="margin:auto">
                        <div class="row">
                            <div class="col-md-0">
                            </div>
                            <div class="col-md-12">
                                <div class="row account-content">
                                    <div class="account-content-d">
                                        <div class="inputs ">
                                            <center>
                                            <p style="font-size: 13px"><strong>Escrow successfully created</strong></p>
                                            <span>Escrow link generated! Please copy and share with the other party</span>

                                            <div class="a-text1">
                                            <button class="btn btn-default copy-refid1" data-toggle="tooltip" data-placement="top" title="" @click="copyToClipboard1(contractLink)">
                                                <i class="fa fa-copy"></i> Copy Link
                                            </button>
                                            
                                            </div>
                                            </center>
                                        </div>
                                    </div>
                                    <button id="submit2" class="btn btn-default font-weight-bold" @click="copied()">X</button>
                                    <p>&nbsp;</p>
                                </div>
                            </div>
                            <div class="col-md-0">
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div> -->
    
        <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
    </template>
    
      
    <script>
    // import 'quill/dist/quill.snow.css';
    // import {
    //     quillEditor
    // } from 'vue-quill-editor';
    
    import swal from 'sweetalert2';
    import PageLoader from '../components/PageLoader.vue'
    export default {
    
        name: "ProductPage",
        components: {
            //quillEditor,
            PageLoader
        },
    
        data() {
            return {
    
                isLoading: false,
                isRightImage: false,
                isLeftImage: false,
                isBackImage: false,
                is_transaction_fee: true,
                is_transaction_fee_hidden: false,
                user_id: '',
                firstname: '',
                lastname: '',
                bank_name: '',
                account_name: '',
                account_number: '',
    
                loading: false,
                loading1: false,
                loading2: false,
                loading3: false,

                selectedFile: '',
                addDispute: false,
                viewDispute: true,
                editorOptions: {
                    placeholder: 'Write something...',
                },

                img_url: process.env.VUE_APP_IMAGE_URL,
                desserts: [],
                header: [
                   
                    {
                        value: 'ticketid',
                        text: '#Ticket number'
                    },
                    {
                        value: 'customer',
                        text: 'Customer'
                    },
                    // {
                    //     value: 'acceptedby',
                    //     text: 'Accepted By'
                    // },
                    {
                        value: 'disputetype',
                        text: 'Dispute topic'
                    },
                    {
                        value: 'contract',
                        text: 'Service title'
                    },
                                       
                    {
                        value: 'description',
                        text: 'Description'
                    },
                    {
                        value: 'priority',
                        text: 'Priority'
                    },
                    {
                        value: 'status',
                        text: 'Status'
                    },
                     {
                        value: 'action',
                        text: 'Action'
                    },
                ],
                dispute_subject: '',
                disputeSubject: [],
                contract_list:'',
                contractList: [],
                dispute_priority: '',
                priorityType: [{
                    text: 'High',
                    value: 'High'
                },
                {
                    text: 'Medium',
                    value: 'Medium'
                },
                {
                    text: 'Low',
                    value: 'Low'
                },
            ],
                dispute_description: '',
                disputeQty: '',

            };
        },
    
        beforeMount() {
    
        },
    
        mounted() {
    
            this.firstname = localStorage.getItem("firstname");
            this.lastname = localStorage.getItem("lastname");
            this.phone_number = localStorage.getItem("phone");
            this.email_address = localStorage.getItem("email");
            this.user_id = localStorage.getItem("userid");
    
            this.bank_name = localStorage.getItem("bank_name");
            this.account_name = localStorage.getItem("account_name");
            this.account_number = localStorage.getItem("account_number");
            this.user_role = localStorage.getItem("user_role");
    
            this.fetch_all_disputes()
        },
    
        created() {
    
        },
    
        computed: {
    
            isDisputeFieldsEnabled() {
                return (
                    this.dispute_subject === '' ||
                    this.contract_list === '' ||
                    this.dispute_priority === '' ||
                    this.dispute_description === ''
                );
            },
    
            indexSn() {
                return this.desserts.map((d, index) => ({
                    ...d,
                    sn: index + 1
                }))
            },

            openDisputes() {
                return this.desserts.filter((item) => Number(item.status) === 1).length
            },

            inProgressDisputes() {
                return this.desserts.filter((item) => Number(item.status) === 2).length
            },

            resolvedDisputes() {
                return this.desserts.filter((item) => Number(item.status) === 3).length
            },

        },
    
        methods: {

            async fetch_all_disputes() {
                try {
    
                    this.desserts = []
                    const response = await this.$http.get('/fetch-all-disputes', {
                    })
                    const dispute_list = response.data.data
                    this.disputeQty = dispute_list.length
                    dispute_list.forEach(el => {
                        this.desserts.push({
                            role: el.role_type,
                            acceptedby: el.accepted_fullname,
                            disputeid:el.disputeid,
                            ticketid: el.ticket_id,
                            customer: el.fullname,
                            disputetype: el.subjects,
                            contract: el.contract_title,
                            description: el.content,
                            priority: el.priority,
                            status: el.dispute_status,
                            action: el.disputeid,
                        })
                    });
    
                } catch (err) {
                    console.log(err);
                }
            },    

            async in_progress(dispute_id){
                try {
    
                    const response = await this.$http.post('/dispute-inprogress', {
                        dispute_id: dispute_id
                    })
                    const success = response.data.success
                    if(success){
                        swal.fire({
                            icon: 'success',
                            title: 'In-process',
                            width: 450,
                            height: 5,
                            text: response.data.message,
                        })

                        this.fetch_all_disputes()
                        return;
                    }
                    else{
                        swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                        })
                        return;
                    }
                   

                } catch (err) {
                    console.log(err);
                }
            },

            async dispute_resolve(dispute_id){
                try {
    
                    const response = await this.$http.post('/dispute-resolved', {
                        dispute_id: dispute_id
                    })
                    const success = response.data.success
                    if(success){
                        swal.fire({
                            icon: 'success',
                            title: 'Resolved',
                            width: 450,
                            height: 5,
                            text: response.data.message,
                        })
                        this.fetch_all_disputes()
                        return;

                    } else{
                        swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                        })
                        return;
                    }
                   

                } catch (err) {
                    console.log(err);
                }
            }
        }
    
    }
    </script>
      
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
    .container-fluid{
    background:
    radial-gradient(circle at top left, rgba(36, 86, 43, 0.12), transparent 24%),
    linear-gradient(180deg, #f4f8f5 0%, #edf3ee 100%);
    border-radius: 10px;
    padding: 1.25rem 1rem 2rem;
    min-height: 100vh;
    }
    .disputes-shell{
        max-width: 1240px;
        margin: 0 auto;
    }
    .disputes-hero{
        display: grid;
        grid-template-columns: 1.35fr 1fr;
        gap: 1.2rem;
        margin-bottom: 1.25rem;
        align-items: stretch;
    }
    .disputes-hero-copy{
        padding: 2rem;
        border-radius: 28px;
        background: linear-gradient(135deg, #16372d 0%, #24562B 58%, #3d7c50 100%);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.1);
        color: #fff;
        font-family: Poppins;
    }
    .hero-eyebrow{
        margin: 0 0 0.65rem;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.12em;
        color: rgba(255,255,255,0.72);
    }
    .disputes-hero-copy h1{
        margin: 0;
        font-size: 32px;
        line-height: 1.15;
        font-weight: 700;
    }
    .hero-text{
        margin: 0.9rem 0 0;
        max-width: 560px;
        font-size: 14px;
        line-height: 1.75;
        color: rgba(255,255,255,0.84);
    }
    .disputes-stats{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 1rem;
        padding: 1rem;
        border-radius: 28px;
        background: rgba(255,255,255,0.72);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07);
        backdrop-filter: blur(10px);
    }
    .disputes-stat-card{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 176px;
        padding: 1.2rem;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f4f8f5 100%);
        border: 1px solid rgba(22, 55, 45, 0.08);
        font-family: Poppins;
    }
    .disputes-stat-card-soft{
        background: linear-gradient(180deg, #f5fbf6 0%, #eef7f0 100%);
    }
    .stat-label{
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: #6f8579;
    }
    .disputes-stat-card strong{
        margin: 0.85rem 0 0.55rem;
        font-size: 28px;
        line-height: 1.2;
        color: #16372d;
        word-break: break-word;
    }
    .stat-note{
        font-size: 12px;
        line-height: 1.6;
        color: #66776f;
    }
    .dispute-summary-grid{
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 1rem;
        margin-bottom: 1.25rem;
    }
    .summary-card{
        padding: 1.15rem 1.2rem;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f7faf8 100%);
        border: 1px solid rgba(22, 55, 45, 0.08);
        box-shadow: 0 18px 38px rgba(11, 39, 24, 0.06);
        font-family: Poppins;
    }
    .summary-card-progress{
        background: linear-gradient(180deg, #f7faff 0%, #edf4ff 100%);
    }
    .summary-card-resolved{
        background: linear-gradient(180deg, #f5fbf6 0%, #edf7ef 100%);
    }
    .summary-label{
        display: block;
        margin-bottom: 0.65rem;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: #6f8579;
    }
    .summary-card strong{
        display: block;
        margin-bottom: 0.45rem;
        font-size: 30px;
        line-height: 1.1;
        color: #16372d;
        font-family: Poppins;
    }
    .summary-card p{
        margin: 0;
        font-size: 12px;
        line-height: 1.65;
        color: #66776f;
        font-family: Poppins;
    }
    .error {
        color: #fff;
      }
      .error1 {
        color: #fff;
      }
    .quill-container {
        height: 200px;
        /* Set the desired height here */
    }
    .copy-refid{
        cursor: pointer;
        font-size: 16px;
    }
    .copy-refid1{
        cursor: pointer;
        font-size: 15px;
        font-weight: 600;
    }
    .a-text {
        font-size: 11px;
        font-family: Poppins;
    }
    .a-text1 {
        font-size: 14px;
        font-family: Poppins;
    }
    .process-payment{
        cursor:pointer;
    
    }
    label {
        font-size: 12px;
        font-family: Poppins;
        font-weight: normal;
    }
    
    .inputs {
        margin-top: 20px;
        border-radius: 3px;
        font-size: 12px;
    }
    
    .price-fee {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    
        div {
            margin: 4px;
            width: 100%;
    
        }
    }
    
    .adjust-fee-input {
        // width: 100px;
        text-align: center;
    }
    
    .whopays-fee-input {
        //width: 100% !important;
    }
    
    .shop-detail {
        font-size: 12px;
        font-family: Poppins;
    }
    
    .btn-danger {
        text-transform: uppercase;
        font-size: 13px;
        font-family: Poppins;
        background: #24562B;
        border: 0px;
        height: 45px;
    }
    
    .contract-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        background: linear-gradient(135deg, #16372d 0%, #24562B 100%);
        color: #fff;
        border-radius: 20px;
        padding: 1rem 1.15rem;
        font-size: 14px;
        font-weight: 700;
        font-family: Poppins;
        margin-bottom: 0.9rem;
    }
    
    .welcome {
        font-family: Poppins;
        font-size: 20px;
        font-weight: 700;
        margin-top: 15px;
        color: #170e0fac;
    }
    
    .account-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 24px;
        background: #fff;
        width: 100%;
    }
    .disputes-table-card{
        padding: 1.15rem;
        border: 1px solid rgba(22, 55, 45, 0.07);
        box-shadow: 0 20px 45px rgba(11, 39, 24, 0.07);
    }
    .disputes-table-inner{
        margin-bottom: 0;
    }
    .disputes-count{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 32px;
        height: 32px;
        padding: 0 0.7rem;
        margin-left: 0.55rem;
        border-radius: 999px;
        background: rgba(255,255,255,0.16);
        font-size: 12px;
        font-weight: 700;
    }
    .disputes-note{
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        color: rgba(255,255,255,0.82);
    }
    .table-heading-meta{
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: wrap;
    }
    .table-meta-chip{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 32px;
        padding: 0.35rem 0.85rem;
        border-radius: 999px;
        background: rgba(255,255,255,0.14);
        border: 1px solid rgba(255,255,255,0.12);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        font-family: Poppins;
    }
    .disputes-table-wrap{
        margin: 0;
        border: 1px solid #e7efea;
        border-radius: 18px;
        overflow: hidden;
        background: #fff;
    }
    .priority-chip,
    .status-chip{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 88px;
        padding: 0.35rem 0.7rem;
        border-radius: 999px;
        font-size: 11px;
        font-weight: 700;
        font-family: Poppins;
    }
    .priority-chip.high{
        background: rgba(199, 42, 42, 0.12);
        color: #b42318;
    }
    .priority-chip.medium{
        background: rgba(206, 145, 24, 0.14);
        color: #a86700;
    }
    .priority-chip.low{
        background: rgba(36, 86, 43, 0.12);
        color: #24562B;
    }
    .status-chip.open{
        background: rgba(199, 42, 42, 0.12);
        color: #b42318;
    }
    .status-chip.progress{
        background: rgba(28, 100, 242, 0.12);
        color: #1d4ed8;
    }
    .status-chip.resolved{
        background: rgba(36, 86, 43, 0.12);
        color: #24562B;
    }
    .dispute-actions{
        display: flex;
        flex-wrap: wrap;
        gap: 0.45rem;
    }
    .dispute-action-btn{
        border: 0;
        border-radius: 999px;
        padding: 0.45rem 0.85rem;
        font-size: 11px;
        font-weight: 700;
        font-family: Poppins;
        box-shadow: none !important;
        transition: transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;
    }
    .secondary-action{
        background: #e8f0ff !important;
        color: #1d4ed8 !important;
    }
    .primary-action{
        background: #24562B !important;
        color: #fff !important;
    }
    .dispute-action-btn:hover:not(:disabled){
        transform: translateY(-1px);
        box-shadow: 0 10px 18px rgba(22, 55, 45, 0.1) !important;
    }
    .dispute-action-btn:disabled{
        opacity: 0.45;
        cursor: not-allowed;
    }
    .disputes-empty-state{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.6rem;
        padding: 2.5rem 1.25rem;
        text-align: center;
        font-family: Poppins;
        color: #60746a;
    }
    .disputes-empty-state i{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #eef6ef;
        color: #24562B;
        font-size: 22px;
    }
    .disputes-empty-state h4{
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #16372d;
    }
    .disputes-empty-state p{
        margin: 0;
        max-width: 420px;
        font-size: 13px;
        line-height: 1.7;
    }
    
    .account-balance {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #780712;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .wallet-detail {
        padding-top: 1rem;
        line-height: 1.4px;
        font-size: 15px;
    
        h4 {
            font-weight: 650;
        }
    
        .acct-d {
            line-height: 0.8;
            cursor: pointer;
            text-decoration: underline;
        }
    }
    
    .wallet-icon {
        font-size: 60px
    }
    :deep(.disputes-data-table .v-data-table__wrapper table) {
        min-width: 1020px;
    }
    :deep(.disputes-data-table thead th) {
        background: #f4f8f5;
        color: #5d7166;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        font-family: Poppins;
        border-bottom: 1px solid #e6eeea;
    }
    :deep(.disputes-data-table tbody td) {
        padding-top: 14px !important;
        padding-bottom: 14px !important;
        border-bottom: 1px solid #eef3ef;
        background: #fff;
        vertical-align: middle;
    }
    :deep(.disputes-data-table tbody tr:hover td) {
        background: #f8fbf8 !important;
    }
    :deep(.disputes-data-table .v-data-footer) {
        border-top: 1px solid #eef3ef;
    }
    
    .fund-account {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background: #076378;
        color: #fff;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        font-family: Poppins;
        padding: 0.4rem;
        padding-left: 2rem;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }
    
    .inputs-field {
        font-size: 14px;
        font-family: Poppins;
        height: 45px;
    }
    
    .content-center {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border: solid 1px #170e0fac;
        border-radius: 4px;
        padding: 0.5rem;
        margin: 4px;
    }
    
    .box1 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .image-input {
        margin-top: 10px;
    }
    
    .box-icon {
        padding-left: 0.4rem;
        font-size: 35px;
        color: #637807;
    }
    
    .box-details {
        font-size: 14px;
        color: #170e0fac;
    }
    
    .box1:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box2:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box3 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box3:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box4 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box4:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box5:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .box6 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        font-family: Poppins;
    
        a {
            text-decoration: none;
            color: #000;
        }
    }
    
    .box6:hover {
        transform: scale(1.1);
        transition: transform 0.3s ease;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.24);
        cursor: pointer;
    }
    
    .img {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    
    .box-details {
        padding: 0.4rem;
        line-height: 1.4px;
    
        .title {
            font-family: Poppins;
            font-weight: 550;
            font-size: 10px;
            text-transform: capitalize;
            color: #ff4d63;
        }
    
        .description {
            font-family: Poppins;
            font-size: 12px;
        }
    }
    
    .continue {
        display: flex;
        flex-direction: row;
        justify-content: right;
        padding-right: 0.4rem;
        font-size: 30px;
        color: rgb(237, 138, 108);
        margin-right: 10px;
        margin-top: -10px;
        margin-bottom: 10px;
    }
    
    .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 90%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #fff;
            ;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Poppins;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Poppins;
        }
    }
    
    .account-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .account-content-h {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50px;
    
        padding-top: 1.3rem;
        text-transform: uppercase;
        text-align: center;
        //text-decoration: underline;
    }
    
    .add-fund {
        font-size: 12px;
        text-decoration: none !important;
        text-transform: capitalize;
    }
    
    .account-content-d {
        padding-top: 1.3rem;
        font-size: 14px;
        margin-bottom: 10px;
    }
    
    .btn-secondary {
        text-transform: uppercase;
    }
    
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    }
    
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;
    
        &:hover {
            color: black;
        }
    
        display: none;
    }
    
    a {
        text-decoration: none;
    }
    
    .shop-name {
        //font-weight: 550;
        color: #000;
        font-family: Poppins;
    }
    
    @media screen and (max-width: 991px) {
        .container-fluid{
            padding: 1rem 0.85rem 1.5rem;
        }
        .disputes-hero{
            grid-template-columns: 1fr;
        }
        .disputes-hero-copy{
            padding: 1.45rem;
        }
        .disputes-hero-copy h1{
            font-size: 26px;
        }
        .disputes-stats{
            grid-template-columns: 1fr;
        }
        .dispute-summary-grid{
            grid-template-columns: 1fr;
        }
        .disputes-stat-card{
            min-height: auto;
        }
        .contract-header{
            flex-direction: column;
            align-items: flex-start;
        }
        .disputes-table-card{
            padding: 0.9rem;
        }
    }

    @media screen and (max-width: 768px) {
        .container-fluid{
        padding: 1rem 0.75rem 1.25rem;
    }
        .copy-refid1{
            cursor: pointer;
            font-size: 14px;
            font-weight: 600;
        }
        .inputs-field {
            font-size: 12px;
            font-family: Poppins;
            font-weight: normal;
            height: 45px;
        }
        .contract-header {
    
            font-size: 12px !important;
    
        }
        .contract-header{
            border-radius: 16px;
            padding: 0.9rem 1rem;
        }
        .disputes-count{
            margin-left: 0.35rem;
        }
        .disputes-note{
            line-height: 1.5;
        }
        .table-heading-meta{
            align-items: flex-start;
        }
        .disputes-table-wrap{
            border-radius: 14px;
        }
        .priority-chip,
        .status-chip{
            min-width: 78px;
            font-size: 10px;
        }
        .dispute-action-btn{
            width: 100%;
            justify-content: center;
        }
    
        .counter {
            font-size: 13px;
            font-weight: 500 !important;
        }
    
        .welcome {
            font-family: Poppins;
            font-size: 16px;
            font-weight: 700;
            text-align: left;
            color: #170e0fac;
        }
    
        .content-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 0.9rem;
        }
    
        .image-input {
            margin-top: 20px;
        }
    
        .price-fee {
            display: flex;
            flex-direction: column;
    
            div {
                width: 100%;
            }
        }
        .margin-mobile{
            margin-top: 90px;;
        }
    
        .adjust-fee-input {
            width: 100%;
        }
    
        .account-details {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            width: 100%;
        }
    
        .account-balance {
            margin-bottom: 10px;
        }
    
        .box-details {
            padding: 0.4rem;
            line-height: 1.4px;
    
            .title {
                font-family: Poppins;
                font-weight: 550;
                font-size: 8px;
                text-transform: capitalize;
                color: #ff4d63;
            }
    
            .description {
                font-family: Poppins;
                font-size: 12px;
            }
        }
    
        .inputs {
            font-size: 12px;
        }
    
        .box1 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box2 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box3 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box4 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .box5 {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            margin-bottom: 10px;
        }
    
        .continue {
            display: flex;
            flex-direction: row;
            justify-content: right;
            padding-right: 0.4rem;
            font-size: 30px;
            margin-top: -10px;
            color: rgb(237, 138, 108);
        }
    
        .modal-close-mobile {
            display: block;
        }
    
        .modal-close {
            display: none;
        }
    
        .account-content {
            margin: 0px;
            margin-right: 0px;
        }
    
    }
    </style>
    
